<template>
    <div class="page-mask" v-show="showMask" @touchmove.prevent v-cloak>
            <h1>活动已结束，下次记得早点来哦~~~</h1>
            <div class="mask" style="z-index: 99999;" v-if="showMask"></div>
        </div>
</template>

<script>

export default {
    name: 'FullMask',
    props:['showMask']
}
</script>


<style scoped>
    .page-mask {
        position: fixed;
        z-index: 99999;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: #000000e6;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    
    .page-mask .pop-body {
        width: 90%;
        position: relative;
    }
    
    .page-mask .img {
        width: 100%;
    }

    h1{
        text-align: center;
        color: #fff;
        font-size: 25px;
    }
    
  

</style>



// WEBPACK FOOTER //
// FullMask.vue?b2d1c28c